import CityPageTemplate from "../city-template/CityPageTemplate";
import { berlinConfig } from "./data";

export default function BerlinPage() {
  return <CityPageTemplate config={berlinConfig} />;
}